import { Box, Typography, Grid } from "@mui/material";
import PropTypes from "prop-types";

const TestimonialsSection = ({ 
  testimonials = [], 
  title, 
  subtitle, 
  description 
}) => {
  // Default testimonial data with social images
  const defaultTestimonials = [
    {
      id: 1,
      name: "Sarah M",
      title: "Registered Dietitian",
      type: "profile",
      nameColor: "white"
    },
    {
      id: 2,
      name: "Timothee Moiroux",
      title: "Medical Dietitian",
      type: "quote",
      quote: "Great! Since your hero section focuses on value proposition, trust, and call-to-action, the next section should naturally support the user's interest by deepening their understanding of your product. Fitify has helped me save hours each week and deliver better care to my clients.",
      timestamp: "10 days ago"
    },
    {
      id: 3,
      name: "Rajesh Nair",
      title: "Registered Dietitian",
      type: "profile",
      nameColor: "#17c1e8"
    }
  ];

  const testimonialsData = testimonials.length > 0 ? testimonials : defaultTestimonials;

  return (
    <Box sx={{ py: 8 }}>
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Typography
          variant="h6"
          sx={{
            color: "#17c1e8",
            fontSize: "1.1rem",
            fontWeight: 500,
            mb: 2,
            fontFamily: "Outfit",
          }}
        >
          {subtitle || "Social Proof / Testimonials"}
        </Typography>

        <Typography
          variant="h2"
          sx={{
            color: "#FFFFFF",
            fontSize: { xs: "2rem", md: "2.8rem", lg: "3.2rem" },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.2,
            fontFamily: "Outfit",
          }}
        >
          {title || "Loved by Dietitians Across the Country"}
        </Typography>

        <Typography
          variant="h6"
          sx={{
            color: "rgba(255, 255, 255, 0.8)",
            fontWeight: 400,
            margin: "0 auto",
            lineHeight: 1.6,
            fontSize: { xs: "1rem", md: "1.1rem" },
            fontFamily: "Outfit",
          }}
        >
          {description || "See how real dietitians are transforming their workflows and client results with Fitify."}
        </Typography>
      </Box>

      <Grid container spacing={4} sx={{ justifyContent: "center" }}>
        {testimonialsData.map((testimonial, index) => (
          <Grid item xs={12} md={6} lg={4} key={testimonial.id}>
            <Box
              sx={{
                width: "100%",
                height: "500px",
                borderRadius: "20px",
                overflow: "hidden",
                position: "relative",
                display: "flex",
                flexDirection: "column",
                // background: "linear-gradient(135deg, #2c5aa0 0%, #1e3a5f 25%, #4a90e2 50%, #2c5aa0 75%, #1e3a5f 100%)",
              }}
            >
              {/* Social Image Background */}
              <Box
                component="img"
                src={require(`assets/images/social${index + 1}.png`)}
                alt={`Social ${index + 1}`}
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex: 1,
                }}
              />
              
              {/* Grid Pattern Overlay */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: `
                    linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
                    linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)
                  `,
                  backgroundSize: "20px 20px",
                  opacity: 0.3,
                  zIndex: 3,
                }}
              />

               {/* Text Content */}
               <Box
                 sx={{
                   position: "relative",
                   zIndex: 4,
                   p: 4,
                   height: "100%",
                   display: "flex",
                   flexDirection: "column",
                   justifyContent: index === 1 ? "space-between" : "flex-end", // Middle card (index 1) shows quote, others show name at bottom
                 }}
               >
                 {index === 1 ? (
                   // Middle card - show quote
                   <>
                     <Typography
                       sx={{
                         color: "#FFFFFF",
                         fontSize: "1.5rem",
                         fontWeight: "bold",
                         mb: 1,
                         fontFamily: "Outfit",
                       }}
                     >
                       {testimonial.name}
                     </Typography>
                     <Typography
                       sx={{
                         color: "#FFFFFF",
                         fontSize: "1rem",
                         opacity: 0.9,
                         mb: 3,
                         fontFamily: "Outfit",
                       }}
                     >
                       {testimonial.title}
                     </Typography>
                     <Typography
                       sx={{
                         color: "#FFFFFF",
                         fontSize: "1rem",
                         lineHeight: 1.6,
                         flex: 1,
                         fontFamily: "Outfit",
                       }}
                     >
                       "{testimonial.quote}"
                     </Typography>
                     <Typography
                       sx={{
                         color: "rgba(255, 255, 255, 0.7)",
                         fontSize: "0.9rem",
                         mt: 2,
                         fontFamily: "Outfit",
                       }}
                     >
                       {testimonial.timestamp}
                     </Typography>
                   </>
                 ) : (
                   // First and last cards - no text, just image
                   null
                 )}
               </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

TestimonialsSection.propTypes = {
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      type: PropTypes.oneOf(["profile", "quote"]),
      quote: PropTypes.string,
      timestamp: PropTypes.string,
      nameColor: PropTypes.string,
    })
  ),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
};

export default TestimonialsSection;
